import { FC } from 'react';
import { HeaderAccountButtonProps } from './types';
import { CatButton } from '@blocks-react/components/Button';
import styles from './HeaderAccountButton.module.scss';

export const HeaderAccountButton: FC<HeaderAccountButtonProps> = ({
  label,
  onClick,
  href,
}) => (
  <div className={styles['header__button--wrapper']}>
    <div className={styles['header__button--content']}>
      <CatButton
        variant="ghost"
        onClick={onClick}
        href={href}
        data-testid="logout-button"
      >
        {label}
      </CatButton>
    </div>
    <hr className={styles['header__button--divider']} />
  </div>
);
